import axios from 'axios';
import * as Cookies from '../utils/cookies';

export async function editRoundDate(league_pk, round_pk, round_date) {
  const token = Cookies.getToken();

  try {
    const res = await axios({
      method: 'PATCH',
      url:
        process.env.REACT_APP_API_URL +
        `/api/league/leagues/${league_pk}/rounds/${round_pk}/`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        round_date: round_date,
      },
    });
    return res;
  } catch (error) {
    return { error: error };
  }
}

